// Define constants for API request URLs
export const api_serverUrl = 'https://admin-api.streams.us/';
export const dashboard_id = '296730252';

export const authDomain = 'https://accounts-ai.streams.us/auth/';

export const authentication_url = authDomain + '?dashboardid=' + dashboard_id + '&src=' + window.location.host + '&se=true'

export const auth_signOut_url = authDomain + 'SignOutServlet?dashboardid=' + dashboard_id + '&src=' + window.location.host + '&se=true'

export const show_links_tab = 0;
export const admin_doc_url = 'https://settings.streams.us'
export const imp_exp_allowed_rows = 500
export const new_admin_domain = 'https://admin-ai.streams.us/';

export const dashboard_streams_exe_id = '309032968';
export const entra_reg_auth_domain = 'https://accounts.unifiedcloudit.com/auth/';

export const call_routing_service_id = 1505;
